
export default {
  name: 'EquivalenceItem',
  props: {
    titleLeft: String,
    textLeft: String,
    textRight: String,
    image: Object,
    noBorder: {
      type: Boolean,
      default: () => false,
    },
  },
};
